
import React from 'react';
import { NavLink } from "react-router-dom";
import "./css/dashboard.css";
import Header from './Header';
import PaymentChartToggle from './PaymentChartToggle';
import PaymentChartWithYear from './PaymentChartWithYear';
import Loader from './Loader'
import { API_BASE_URL, ResidentGetAPIEndpoint,  NoticesGetAPIEndpoint, ExpenseMonthlyAmountAPIEndpoint } from '../constant';

import  { useState, useEffect } from 'react';
import { monthlyData, yearlyData,  incomeExpenseMonthly, incomeExpenseYearly, monthlyDataByYear } from './mockData';



// function Dashboard() {
//   return (
//     <div>
//       <h1>Dashboard</h1>
//       <div className="cards">
//         <div>Residents: {residentsMock.length}</div>
//         <div>Payments: {paymentsMock.length}</div>
//         <div>Notices: {noticesMock.length}</div>
//       </div>
//     </div>
//   );
// }

/*function Dashboard() {
    const residents = JSON.parse(localStorage.getItem('residents') || '[]').length;
    const payments = JSON.parse(localStorage.getItem('payments') || '[]').length;
    const notices = JSON.parse(localStorage.getItem('notices') || '[]').length;

    //const [isLoggedIn, setIsLoggedIn] = useState(false);

    //return (
        /*<div>
            <h1>Dashboard</h1>
            <div className='cards'>
                <div>Residents: {residents}</div>
                <div>Payments: {payments}</div>
                <div>Notices: {notices}</div>
            </div>
        </div>*/

        /*<Router>
          {isLoggedIn && (
        <nav>
          <Link to="/">Dashboard</Link> | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/residents">Residents</Link> | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/payments">Payments</Link> | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/notices">Notices</Link>
          <button onClick={() => setIsLoggedIn(false)}>Logout</button>
        </nav>
      )}
            
        <Routes>
            {<Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />}
            <Route path='/' element={<Dashboard />} />                
            <Route path='/residents' element={<Residents />} />
            <Route path='/payments' element={<Payments />} />
            <Route path='/notices' element={<Notices />} />
        </Routes>
      </Router>*/
    //);
//}
    
function Dashboard() {
  
    const residents = JSON.parse(localStorage.getItem('residents') || '[]').length;
    const payments = JSON.parse(localStorage.getItem('payments') || '[]').length;
    const notices = JSON.parse(localStorage.getItem('notices') || '[]').length;
    const [residentCount, setResidentCount] = useState(0);
     const [noticeCount, setNoticeCount] = useState(0);
      const [showLoader, setShowLoader] = useState(true);
      const [year, setYear] = useState(new Date().getFullYear());
    const [monthlyDataByYearChart, setMonthlyDataByYearChart] = useState([]);
      

 useEffect(() => {
   const timer = setTimeout(() => {
      setShowLoader(false);
    }, 2000); 

    const fetchResidents = async () => {

      const residentApiUrl = API_BASE_URL + ResidentGetAPIEndpoint;
      const noticeApiUrl = API_BASE_URL + NoticesGetAPIEndpoint;
      const token = sessionStorage.getItem("JWTtoken");
      //console.log("Before Token => " + token);
      //const updatedToken = token.replace("a", "9");
      //console.log("After Token => " + updatedToken);

      try {
        const [response1, response2] = await Promise.all([
          fetch(residentApiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        } } ), // Replace with actual API endpoints
          fetch(noticeApiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        })
        ]);

        const result1 = await response1.json();
        const result2 = await response2.json();

        if(result1.status){
           setResidentCount(result1.data.length);
        }
        if(result2.status){
          setNoticeCount(result2.data.length);
        }

      } catch(err){
        setResidentCount(0);
        setNoticeCount(0);
      }
      
      




      try {
        const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;
        const token = sessionStorage.getItem("JWTtoken");
        const response = await fetch(apiURL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        } });
        const data = await response.json();
        //alert(JSON.stringify(data));
        if (data.status) {
          setResidentCount(data.data.length);
        } else {
          setResidentCount(0);
        }
      } catch (err) {
        setResidentCount(0);
      } 


      /*try {
        const apiURL = API_BASE_URL + ExpenseMonthlyAmountAPIEndpoint + '?year=' + year;
        const response = await fetch(apiURL);
        const data = await response.json();
        alert(data.status);
        if (data.status) {
          const result = data.data.map(item => ({
            month: item.month_name,
            amount: item.Total
        }));

        alert(JSON.stringify(result));
        setMonthlyDataByYearChart(result);        
        } else {
          setMonthlyDataByYearChart([]);
        }
      } catch (err) {
        setMonthlyDataByYearChart([]);
      }*/


    };



    const fetchNotices = async() => {
      setNoticeCount(5);
    };

    fetchResidents()},[]);

  return (<> 

  <Header/>
    <div>
            <h1>Dashboard</h1>
            <div className='cards'>
                <div>Residents: {residentCount}</div>
                <div>Payments: {payments}</div>
                <div>Notices: {noticeCount}</div>
            </div>
            {
              showLoader && <Loader/>
            }
            {
               

              <div>
              <div > 
                
                <h1>Payment Data</h1>
                {/*<PaymentChartToggle
                  monthlyData={monthlyData}
                  yearlyData={yearlyData}                
                />*/}
                <PaymentChartToggle
                  monthlyData={monthlyData}
                  yearlyData={yearlyData}    
                  incomeExpenseData = {incomeExpenseMonthly}   
                  incomeExpenseYearlyData = {incomeExpenseYearly}     
                />
              </div>
                <div> 
                  <h1>Payment Chart With Year</h1>
                  <PaymentChartWithYear
                    monthlyDataByYear={monthlyDataByYear}
                    // monthlyDataByYear={monthlyDataByYearChart}
                    yearlyData={yearlyData}
                  />
                </div>
            </div>

            }
            
    </div>  
     </>
  );   
}
export default Dashboard;
